import { MainTemplate } from "@/components/templates";
import Router from "next/router";
import config from "@/libs/config";
import * as util from "@/libs/util";

export const BizsolRedirectToAuthPage = () => {
  const fqdn = config.BIZSOL_FQDN;

  const queryString = util.objToQueryString({
    response_type: "code",
    client_id: config.BIZSOL_CLIENT_ID,
    redirect_uri: config.BIZSOL_REDIRECT_URI,
    scope: "openid",
    max_age: "3600",
  });

  const url = `https://${fqdn}/bizsol/v1/banks/${config.BANK_CODE}/oauth/auth?${queryString}`;
  Router.push(url);

  return <MainTemplate></MainTemplate>;
};
